<ion-button
  fill="clear"
  [color]="hasIssue ? 'warning' : 'light'"
  class="server-connectivity-indicator"
  (click)="showDetails()"
  [attr.title]="(hasIssue ? 'CONNECTIVITY.INDICATOR_TITLE' : 'CONNECTIVITY.INDICATOR_OK_TITLE') | translate"
>
  <ion-icon slot="icon-only" [name]="hasIssue ? 'cloud-offline-outline' : 'cloud-done-outline'"></ion-icon>
</ion-button>
